document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.js-community-images');
  if (!container) return;

  const images = container.querySelectorAll('.js-community-image');
  const elements = [];

  images.forEach(el => {
    const computed = getComputedStyle(el);
    const baseX = parseFloat(computed.left) || 0;
    const baseY = parseFloat(computed.top) || 0;

    const width = el.offsetWidth;
    const height = el.offsetHeight;

    const element = {
      el,
      baseX,
      baseY,
      offsetX: 0,
      offsetY: 0,
      dx: randomVelocity(),
      dy: randomVelocity(),
      width,
      height
    };

    elements.push(element);
    el.style.willChange = 'transform';

    setInterval(() => {
      element.dx = randomVelocity();
      element.dy = randomVelocity();
    }, 5000 + Math.random() * 3000);
  });

  function randomVelocity() {
    const speed = 0.1 + Math.random() * 0.1;
    return (Math.random() < 0.5 ? -1 : 1) * speed;
  }

  function animate() {
    const maxOffset = 30;

    elements.forEach(item => {
      item.offsetX += item.dx;
      item.offsetY += item.dy;

      if (item.offsetX >= maxOffset || item.offsetX <= -maxOffset) {
        item.dx *= -1;
        item.offsetX = Math.max(-maxOffset, Math.min(maxOffset, item.offsetX));
      }

      if (item.offsetY >= maxOffset || item.offsetY <= -maxOffset) {
        item.dy *= -1;
        item.offsetY = Math.max(-maxOffset, Math.min(maxOffset, item.offsetY));
      }

      item.el.style.transform = `translate(${item.offsetX}px, ${item.offsetY}px)`;
    });

    requestAnimationFrame(animate);
  }

  animate();
});